import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller'
import { Icon } from 'atoms';
import { CheckboxSvg } from 'components/icons';
import internalState from './internalState';
import { MakeReadyItemCellWrapper, Td } from 'wrappers';

export const definition = {
  name: 'CheckboxCell',
  controller: Controller,
  initialProps: ({ displayConfetti, data, showCheckboxes }) => ({ displayConfetti, data, showCheckboxes }),
  props: internalState,
  elements: [
    {
      wrapper: MakeReadyItemCellWrapper,
      name: 'Selector',
      renderIf: ({ displayConfetti }) => !displayConfetti,
      isButton: true,
      bindings: ({ data, showCheckboxes }) => ({ data, showCheckboxes }),
      displayState: ({ showCheckboxes }) => ({ background: showCheckboxes ? '#F7F7F7' : '' }),
      elements: [
        {
          component: Icon,
          name: 'Checkbox',
          renderIf: ({ showCheckboxes }) => !showCheckboxes,
          displayValue: ({ data }) => CheckboxSvg({ checked: data?.data === 'true' ? true : false })
        },
      ]
    },
  ]
}

export default wrap(ContainerComponent(definition), Td)